/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import workItemDeploymentTabImg from './assets/deployment-tab-skeleton.tpl.svg';
import insightsImg from './assets/insights.tpl.svg';
import onCallPanelImg from './assets/on-call-panel-skeleton.tpl.svg';
import periscopePageFullImg from './assets/periscope-page-full-layout.tpl.svg';
import suggestionsImg from './assets/suggestions.tpl.svg';
import workItemVulnTabImg from './assets/vuln-tab-skeleton.tpl.svg';
import workItemsImg from './assets/work-items.tpl.svg';
import codeAgentsTabSkeletonImg from './assets/code-agents-tab-skeleton.tpl.svg';

const PeriscopePageSkeletonStyles = css({
	width: '100%',
	height: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	object: {
		border: 'none',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	img: {
		border: 'none',
	},
});

// We can probably delete this component in the future coz we are using the composed full layout in periscope skeletons
export const PeriscopePageSkeleton = () => (
	<div
		css={PeriscopePageSkeletonStyles}
		data-testid="skeletons.ui.periscope-page.app-skeleton-image-periscope-page-new"
	>
		<AppSkeletonImage src={periscopePageFullImg} />
	</div>
);

export const PeriscopeSuggestionsSkeleton = () => (
	<div
		css={PeriscopePageSkeletonStyles}
		data-testid="skeletons.ui.periscope-page.app-suggestions-skeleton"
	>
		<AppSkeletonImage src={suggestionsImg} />
	</div>
);

export const PeriscopeInsightsSkeleton = () => (
	<div
		css={PeriscopePageSkeletonStyles}
		data-testid="skeletons.ui.periscope-page.app-insights-skeleton"
	>
		<AppSkeletonImage src={insightsImg} />
	</div>
);

export const PeriscopeWorkItemsSkeleton = () => (
	<div css={PeriscopePageSkeletonStyles}>
		<AppSkeletonImage src={workItemsImg} />
	</div>
);

export const DevelopmentPageWorkItemsVulnTabSkeleton = () => (
	<div css={PeriscopePageSkeletonStyles}>
		<AppSkeletonImage src={workItemVulnTabImg} />
	</div>
);

export const DevelopmentPageWorkItemsDeploymentTabSkeleton = () => (
	<div css={PeriscopePageSkeletonStyles}>
		<AppSkeletonImage src={workItemDeploymentTabImg} />
	</div>
);

export const DevelopmentPageOnCallPanelSkeleton = () => (
	<div
		css={PeriscopePageSkeletonStyles}
		data-testid="skeletons.ui.periscope-page.app-on-call-panel-skeleton"
	>
		<AppSkeletonImage src={onCallPanelImg} />
	</div>
);

export const DevelopmentPageCodeAgentsTabSkeleton = () => (
	<div
		css={PeriscopePageSkeletonStyles}
		data-testid="skeletons.ui.periscope-page.code-agents-tab-skeleton"
	>
		<AppSkeletonImage src={codeAgentsTabSkeletonImg} />
	</div>
);
